import React, { Component } from 'react';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'

import { Request } from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Header from './../../APP/COMPONENTS/Header';
import LeftNav from './../../APP/COMPONENTS/LeftNav';
import Loader from './../../APP/COMPONENTS/Loader';

function mapStateToProps(state, myProps) {
    return {
        USER: state.USER
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}


class Tenders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            USER: this.props.USER,
            LOADED: false,
            TENDERS: []
        }
    }


    componentDidMount = () => {
        this.fetchTenders()
    }


    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.USER !== prevProps.USER) {
            this.setState({ USER: this.props.USER });
        }
    }

    fetchTenders = async () => {
        try {
            let SEND_DATA = {};

            let data = await Request(SEND_DATA, 'tenders/listing');
            if (data !== false) {
                this.setState({ TENDERS: data, LOADED: true });
            } else {
                this.setState({ LOADED: true });
            }
        } catch (error) {
        }
    }

    renderFiter = () => {
        return null
    }

    filterTenders = () => {
        let TENDERS = this.state.TENDERS
        let FILTERED_TENDERS = TENDERS

        return FILTERED_TENDERS
    }

    renderStatusBadge = (status) => {
        let title = 'Новый';
        let className = 'new';

        switch (parseInt(status)) {
            case 1:
                title = 'Активный';
                className = 'talk';
                break;
            case 2:
                title = 'Завершен';
                className = 'done';
                break;
        }

        return <span className={ 'order_status ' + className }>{ title }</span>
    }

    renderTendersRows = (TENDERS, SAVEABLE) => {
        let ROWS = [];
        for (let i = 0; i < TENDERS.length; i++) {
            let TENDER = TENDERS[i];

            ROWS.push(
                <tr key={ i }>
                    <td>{ this.renderStatusBadge(TENDER.status) }</td>
                    <td>{ TENDER.id }</td>
                    <td className="cell-center">{ TENDER.ru_created_full }</td>
                    <td className="cell-center">{ TENDER.name }</td>
                    <td><Link to={ "/tenders/" + TENDER.id } className="my_own_price">перейти</Link></td>
                </tr>
            );
        }

        return (
            <tbody>
                { ROWS }
            </tbody>
        );
    }

    renderTendersTableHeader = () => {
        return (
            <thead>
                <tr>
                    <th>статус</th>
                    <th>номер</th>
                    <th>дата создания</th>
                    <th>название</th>
                    <th></th>
                </tr>
            </thead>
        );
    }

    renderTenders = () => {
        if (this.state.LOADED) {
            if (this.state.TENDERS.length) {
                let TENDERS = this.filterTenders();
                let TBODY = this.renderTendersRows(TENDERS);
                let HEADER = this.renderTendersTableHeader();

                return (
                    <div className="table_holder">
                        <table id="products_table" className="products_table" cellPadding="0" cellSpacing="0">
                            { HEADER }
                            { TBODY }
                        </table>
                    </div>
                );

            } else {
                return <div className="table_holder"><h3>Мы не нашли тендеров</h3></div>;
            }
        } else {
            return <div className="table_holder"><Loader /><div className="loader_content">Собираем статистику по тендерам ...</div></div>
        }
    }

    render() {
        if (!this.state.USER) {
            return <Redirect to="/" />
        }

        return (
            <div className="main_content">
                <Helmet>
                    <title>Тендеры</title>
                </Helmet>
                <h1>Тендеры</h1>
                { this.renderFiter() }
                { this.renderTenders() }
            </div>
        );
    }
}

export default withRouter(connect(
    mapStateToProps, mapDispatchToProps
)(Tenders))
